module.exports = __webpack_public_path__ + "img/success.80df7fbe.png";